import React, { FC, PropsWithChildren, ReactNode } from 'react';

import { Stack } from '../Stack';
import { Typography } from '../Typography';


export interface DialogModalProps {
    title: string | ReactNode;
    text?: ReactNode;
    addition?: ReactNode;
}
export const DialogModal: FC<PropsWithChildren<DialogModalProps>> = ({
    title, text, addition, children,
}) => (
    <Stack
        py={10}
        px={8}
        spacing={8}
        alignItems='flex-start'
        bgcolor='grayscale.shade0'
        borderRadius={8}
        width={({ spacing }) => spacing(120)}
    >
        <Stack spacing={2}>
            <Typography variant='mediumHeader1'>
                {title}
            </Typography>
            {(text || addition) && (
                <Stack>
                    {text && (
                        <Typography component='p' variant='regularCaption1' color='grayscale.shade85'>
                            {text}
                        </Typography>
                    )}
                    {addition}
                </Stack>
            )}
        </Stack>
        {children}
    </Stack>
);
